import { defineProperty as _defineProperty } from '../_virtual/_rollupPluginBabelHelpers.mjs';
import { MetaplexError } from './MetaplexError.mjs';

/** @group Errors */
class ReadApiError extends MetaplexError {
  constructor(message, cause) {
    super(message, 'rpc', undefined, cause);
    _defineProperty(this, "name", 'ReadApiError');
  }
}

export { ReadApiError };
//# sourceMappingURL=ReadApiError.mjs.map
